import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { State } from '../redux/redux.state';
import { Coupon } from '../models/coupon';
import client from '../clients/client';
import { CreateOrUpdateCouponRequest } from '../requests/create.or.update.coupon.request';
import { Status } from '../redux/redux.status';

type CouponState = State<Coupon[]> & {
  createCouponStatus: Status;
};

export const initialState: CouponState = {
  data: [],
  status: 'idle',
  createCouponStatus: 'idle',
};

export const getCoupons = createAsyncThunk<Coupon[]>(
  'coupons/getcoupons',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.get('/coupons');
      return data;
    } catch (error: any) {
      const { status, data } = error.reponse;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

export const createOrUpdateCoupon = createAsyncThunk<
  Coupon,
  CreateOrUpdateCouponRequest
>(
  'coupons/createCoupon',
  async (request: CreateOrUpdateCouponRequest, { rejectWithValue }) => {
    try {
      const { data } = await client.post('/coupons/create', request);
      return data;
    } catch (err: any) {
      const { status, data } = err.response;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

const actionSlice = createSlice({
  name: 'couponReducer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCoupons.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createOrUpdateCoupon.pending, (state) => {
        state.createCouponStatus = 'loading';
      })
      .addCase(getCoupons.fulfilled, (state, action) => {
        state.status = 'successful';
        state.data = action.payload;
      })
      .addCase(createOrUpdateCoupon.fulfilled, (state, action) => {
        state.createCouponStatus = 'successful';
      })
      .addCase(getCoupons.rejected, (state, action) => {
        state.status = 'error';
        state.errors = action.payload;
      })
      .addCase(createOrUpdateCoupon.rejected, (state, action) => {
        state.createCouponStatus = 'error';
        state.errors = action.payload;
      });
  },
});

export default actionSlice.reducer;
